import { Injectable } from '@angular/core';
import { AlertService } from '../alert/alert.service';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class DelegatedAuthenticationService {

    constructor (private authService: AuthService,
      private alertService: AlertService) {
    }

    login(issuer: string): Promise<string> {
        return this.authService.login(issuer)
            .catch(error => {
                this.alertService.error('brapi-sync.connections.error.cannot-login');
                throw error;
            });
    }

}
